(function () {
    'use strict';

    angular
        .module('app')
        .controller('ResetTokenController', ResetTokenController);

    ResetTokenController.$inject = ['authentication', '$state', '$modalInstance', 'config'];

    function ResetTokenController(authentication, $state, $modalInstance, config) {
        var vm = this;
        vm.modalTitle = "Reset Token";
        vm.onSubmit = onSubmit;

        vm.casServer = null;
        vm.resetUrl = null;
        vm.accountManagementUrl = window.location.origin;

        activate();

        function activate() {
            config.get().then(function(configData){
                vm.casServer = configData.casServer;
            });
        }

        function onSubmit() {
            // Create the URL
            vm.resetUrl = vm.casServer + "login?service=" + vm.accountManagementUrl + "&onetimeTicket=" + vm.token.trim();

            // Redirect the user to the URL
            window.location.assign(vm.resetUrl);
        }
    }
})();